import Immutable from 'immutable';
import {
  FLAG_GETTING_BANK_RECONCILIATIONS,
  GET_BANK_RECONCILIATIONS,
  CLEAR_BANK_RECONCILIATIONS,
  FLAG_GETTING_BANK_RECONCILIATION_LIQUIDATIONS,
  GET_BANK_RECONCILIATION_LIQUIDATIONS,
  CLEAR_BANK_RECONCILIATION_LIQUIDATIONS,
  FLAG_GETTING_BANK_RECONCILIATION_DEPOSITS,
  GET_BANK_RECONCILIATION_DEPOSITS,
  CLEAR_BANK_RECONCILIATION_DEPOSITS,
  FLAG_GETTING_BANK_RECONCILIATION_BANK_SUMMARY,
  GET_BANK_RECONCILIATION_BANK_SUMMARY,
  CLEAR_BANK_RECONCILIATION_BANK_SUMMARY,
  FLAG_GETTING_BANK_RECONCILIATION_CORPORATES,
  GET_BANK_RECONCILIATION_CORPORATES,
  CLEAR_BANK_RECONCILIATION_CORPORATES,
  FLAG_GETTING_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS,
  GET_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS,
  CLEAR_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS,
  FLAG_GETTING_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS,
  GET_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS,
  CLEAR_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  liquidationsByDate: Immutable.Map(),
  corporatesByDate: Immutable.Map(),
  manualVouchersByCorporate: Immutable.Map(),
  paymentsByManualVoucher: Immutable.Map(),
  depositsByLiquidation: Immutable.Map(),
  bankSummary: Immutable.Map({
    bankList: Immutable.List(),
    bankTotal: null,
    liquidationSummary: null,
    loading: false,
  }),
});

const corporateManualVouchersPath = ({
  date,
  holderType,
  corporateId,
  currency,
}) => ['manualVouchersByCorporate', date, holderType, corporateId, currency];

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BANK_RECONCILIATIONS:
      return state.setIn(['all', 'loading'], payload);
    case GET_BANK_RECONCILIATIONS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BANK_RECONCILIATIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_GETTING_BANK_RECONCILIATION_LIQUIDATIONS:
      return state.setIn(
        ['liquidationsByDate', payload.date, 'loading'],
        payload.flag,
      );
    case GET_BANK_RECONCILIATION_LIQUIDATIONS:
      return state.setIn(
        ['liquidationsByDate', payload.date],
        Immutable.Map({
          content: Immutable.List(payload.content),
          loading: false,
        }),
      );
    case CLEAR_BANK_RECONCILIATION_LIQUIDATIONS:
      return state.deleteIn(['liquidationsByDate', payload.date]);

    case FLAG_GETTING_BANK_RECONCILIATION_CORPORATES:
      return state.setIn(
        ['corporatesByDate', payload.date, 'loading'],
        payload.flag,
      );
    case GET_BANK_RECONCILIATION_CORPORATES:
      return state.setIn(
        ['corporatesByDate', payload.date],
        Immutable.Map({
          content: Immutable.List(payload.content),
          loading: false,
        }),
      );
    case CLEAR_BANK_RECONCILIATION_CORPORATES:
      return state.deleteIn(['corporatesByDate', payload.date]);

    case FLAG_GETTING_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS:
      return state.setIn(
        [...corporateManualVouchersPath(payload), 'loading'],
        payload.flag,
      );
    case GET_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS:
      return state.setIn(
        corporateManualVouchersPath(payload),
        Immutable.Map({
          content: Immutable.List(payload.content),
          loading: false,
        }),
      );
    case CLEAR_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS:
      return state.deleteIn(corporateManualVouchersPath(payload));

    case FLAG_GETTING_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS:
      return state.setIn(
        ['paymentsByManualVoucher', payload.manualVoucherId, 'loading'],
        payload.flag,
      );
    case GET_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS:
      return state.setIn(
        ['paymentsByManualVoucher', payload.manualVoucherId],
        Immutable.Map({
          content: Immutable.List(payload.content),
          loading: false,
        }),
      );
    case CLEAR_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS:
      return state.deleteIn([
        'paymentsByManualVoucher',
        payload.manualVoucherId,
      ]);

    case FLAG_GETTING_BANK_RECONCILIATION_DEPOSITS:
      return state.setIn(
        ['depositsByLiquidation', payload.liquidationId, 'loading'],
        payload.flag,
      );
    case GET_BANK_RECONCILIATION_DEPOSITS:
      return state.setIn(
        ['depositsByLiquidation', payload.liquidationId],
        Immutable.Map({
          content: Immutable.List(payload.content),
          loading: false,
        }),
      );
    case CLEAR_BANK_RECONCILIATION_DEPOSITS:
      return state.deleteIn(['depositsByLiquidation', payload.liquidationId]);

    case FLAG_GETTING_BANK_RECONCILIATION_BANK_SUMMARY:
      return state.setIn(['bankSummary', 'loading'], payload);
    case GET_BANK_RECONCILIATION_BANK_SUMMARY:
      return state
        .setIn(['bankSummary', 'bankList'], Immutable.List(payload.bankList))
        .setIn(['bankSummary', 'bankTotal'], payload.bankTotal)
        .setIn(
          ['bankSummary', 'liquidationSummary'],
          payload.liquidationSummary,
        );
    case CLEAR_BANK_RECONCILIATION_BANK_SUMMARY:
      return state.set('bankSummary', INITIAL_STATE.get('bankSummary'));

    default:
      return state;
  }
};
